(() => {
  const init=root=>root.querySelectorAll?.('[data-s7-performance]').forEach(section=>{
    if(section.dataset.ready)return;section.dataset.ready='1';
    const counts=[...section.querySelectorAll('[data-count]')];let counted=false;
    const obs=new IntersectionObserver(entries=>{if(entries[0].isIntersecting&&!counted){counted=true;counts.forEach(el=>{const t=Number(el.dataset.count)||0,s=performance.now();const tick=n=>{const p=Math.min(1,(n-s)/900);el.textContent=Math.round(t*(1-Math.pow(1-p,3)));if(p<1)requestAnimationFrame(tick)};requestAnimationFrame(tick);});}},{threshold:.3});obs.observe(section);
    const num=section.querySelector('[data-speed-num]'),label=section.querySelector('[data-speed-label]'),step=section.querySelector('[data-speed-step]'),fill=section.querySelector('[data-speed-fill]');
    section.querySelectorAll('[data-speed]').forEach(btn=>btn.addEventListener('click',()=>{section.querySelectorAll('[data-speed]').forEach(b=>b.classList.toggle('is-active',b===btn));num.textContent=btn.dataset.speed;label.textContent=btn.dataset.label;step.textContent=btn.dataset.step+' / 3';fill.style.width=(Number(btn.dataset.step)/3*100)+'%';}));
  });
  if (window.__ISWS7Performance) {
    window.__ISWS7Performance.init(document);
    return;
  }

  window.__ISWS7Performance = { init };

  const boot = () => window.__ISWS7Performance.init(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Motion lifecycle event: theme assets are fully ready.
  document.addEventListener('page:loaded', boot);

  // Shopify Theme Editor section reload.
  document.addEventListener('shopify:section:load', e => {
    window.__ISWS7Performance.init(e.target);
  });
})();